import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';

import { environment } from './environments/environment';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import {
  MatRippleModule,
  provideNativeDateAdapter,
} from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { providePortfolioFirebaseApi } from '@dges/modules/portfolio/api/firebase';
import { providePortfolioNgrxStore } from '@dges/modules/portfolio/store/ngrx';
import { SnackbarService } from '@dges/ui/snackbar';
import { SNACKBAR_FACADE } from '@dges/modules/snackbar';
import { provideStorageFirebaseApi } from '@dges/modules/storage/api/firebase';
import { provideStorageNgrxStore } from '@dges/modules/storage/store/ngrx';
import { provideAuthFirebaseApi } from '@dges/modules/auth/api/firebase';
import { provideAuthNgrxStore } from '@dges/modules/auth/store/ngrx';
import { RootStoreModule } from './app/root-store.module';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      MatSidenavModule,
      MatButtonModule,
      MatToolbarModule,
      MatListModule,
      MatDialogModule,
      MatMenuModule,
      MatRippleModule,
      MatIconModule,
      RootStoreModule,
    ),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    provideStorage(() => getStorage()),
    providePortfolioFirebaseApi(),
    providePortfolioNgrxStore(),
    { provide: SNACKBAR_FACADE, useExisting: SnackbarService },
    provideNativeDateAdapter(),
    provideStorageFirebaseApi(),
    provideStorageNgrxStore(),
    provideAuthFirebaseApi(),
    provideAuthNgrxStore(),
  ],
}).catch((err) => console.error(err));
